import { useTranslation } from 'react-i18next';
import { errorMessageKey } from '@/lib/errors';

export function LoadingState({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3 py-12 text-ink-3 text-sm">
      <span className="inline-block h-2 w-2 rounded-full bg-accent animate-pulse" />
      <span>{label ?? t('states.loading')}</span>
    </div>
  );
}

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps) {
  const { t } = useTranslation();
  const key = errorMessageKey(error);
  return (
    <div
      role="alert"
      className="border border-danger/40 bg-danger/5 rounded-lg p-6 max-w-xl
                 animate-fade-up"
    >
      <div className="font-sans text-sm font-semibold text-danger mb-2">
        {t('errors.title')}
      </div>
      <div className="text-ink mb-4">{t(key)}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="text-xs font-medium px-3 py-1.5 rounded
                     border border-danger/40 text-danger
                     hover:bg-danger/10 transition-colors"
        >
          {t('states.retry')}
        </button>
      )}
    </div>
  );
}

interface EmptyStateProps {
  title: string;
  body?: string;
}

export function EmptyState({ title, body }: EmptyStateProps) {
  return (
    <div className="border border-dashed border-border-2 rounded-lg p-12 text-center
                    animate-fade-up">
      <div className="font-sans text-sm font-semibold text-ink-3 mb-2">{title}</div>
      {body && <div className="text-xs text-ink-4">{body}</div>}
    </div>
  );
}
